'use client';

import { TopPlaceImage } from "@/components/atoms/TopPlaceImage";
import { TopPlaceInformation } from "@/components/atoms/TopPlaceInformation";
import { GlutenFreeMenu } from "@/components/molecules/GlutenFreeMenu";
import { GlutenFreeUserReview } from "@/components/molecules/GlutenFreeUserReview";
import { TopPlaceFrame } from "@/components/atoms/TopPlaceFrame";
import { GlutenFreeAlsoFeaturedIn } from "@/components/molecules/GlutenFreeAlsoFeaturedIn";

export const GlutenFreeTopPlace = ({
    place = {},
    priority,
    position,
    isMobile,
    link,
}) => {
    const title = place.title;
    const thumbnailImageId = place.thumbnail_image_id;
    const address = place.geocode_address?.formatted_address;
    const recommendationsCount = place.total_recommendations;
    const secondaries = place.secondaries && place.secondaries[0];

    return (
        <TopPlaceFrame placeId={place?._id}>
            <TopPlaceImage
                priority={priority}
                title={title}
                id={thumbnailImageId}
                positionNumber={position}
            />
            <TopPlaceInformation
                description={place.description}
                blurb={place.step_generated_blurb?.blurb || ""}
                tags={place.selected_tags}
                recommendationsCount={recommendationsCount}
                title={title}
                address={address}
                gfIdentityData={place.gf_identity_data}
                isMobile={isMobile}
            />
            <div className="flex flex-col gap-0 text-blue-900">
                <GlutenFreeUserReview
                    linkToReview={secondaries?.google_review_data?.google_review_url}
                    userName={secondaries?.creator_preview?.display_name}
                    userAvatarId={secondaries?.creator_preview?.image}
                    reviewText={secondaries?.text}
                    pageTitle={title}
                    position={position}
                    isMobile={isMobile}
                />
                <GlutenFreeMenu
                    pageTitle={title}
                    position={position}
                    isMobile={isMobile}
                    menuDataCopy={place.gf_identity_data?.menu_data?.menu_component_copy}
                    link={link}
                />
                <GlutenFreeAlsoFeaturedIn
                    data={place.also_in_pages || []}
                    position={position}
                    pageTitle={title}
                    isMobile={isMobile}
                />
            </div>
        </TopPlaceFrame>
    );
};
